import { EnterpriseHandle, EnterpriseUid, OrganizationHandle, OrganizationUid } from "@buildwithflux/models";
import { z } from "zod";
export const FindEnterpriseOrganizationRequestData = z.object({
    enterpriseHandle: EnterpriseHandle,
    organizationHandle: OrganizationHandle.nullish(),
});
export const FindEnterpriseOrganizationResponseData = z
    .object({
    enterpriseUid: EnterpriseUid,
    defaultOrganizationUid: OrganizationUid,
    organizationUid: OrganizationUid.nullish().transform((val) => val ?? undefined),
})
    .or(z.literal("not-found"));
//# sourceMappingURL=enterprise.js.map